/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    bed_unit?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom(value: object): value is IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'bed_unit': json['bed_unit'] == null ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON(json['bed_unit']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'bed_unit': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON(value['bed_unit']),
    };
}

